import { BsCarFrontFill, BsDiagram3, BsFillHouseFill, BsTag } from "react-icons/bs";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { IoSettingsOutline } from "react-icons/io5";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { MdOutlineAccountTree, MdOutlineAssignmentInd, MdOutlineChecklist, MdOutlineTwoWheeler, MdOutlineBuild, MdOutlineSchedule, MdOutlineFactCheck, MdOutlineEventBusy, MdOutlineMyLocation } from "react-icons/md";
import { MdOutlineSupportAgent, MdOutlinePeopleAlt } from "react-icons/md";
import { BsQuestionCircle, BsCalendarPlus, BsShieldCheck, BsCalendarRange, BsTicketPerforated, BsCreditCard2Front, BsBell, BsMegaphone, BsSend, BsStar } from "react-icons/bs";

export const sidebarMenu = [
    {
        title: "MAIN",
        items: [
            { name: "Dashboard", icon: <BsFillHouseFill />, path: "/dashboard", check: "dashboard" },
        ],
    },
    {
        title: "CLIENTS",
        items: [
            { name: "Customers", icon: <MdOutlinePeopleAlt />, path: "/customers", check: "customers" },
            { name: "Associates", icon: <HiOutlineUserGroup />, path: "/associates", check: "associates" },
            { name: "Support Tickets", icon: <MdOutlineSupportAgent />, path: "/tickets", check: "tickets" },
            { name: "FAQ", icon: <BsQuestionCircle />, path: "/faq", check: "faq" },
        ],
    },
    {
        title: "BOOKINGS",
        items: [
            { name: "Bookings", icon: <BsCalendarPlus />, path: "/booking", check: "booking" },
            { name: "Payments", icon: <BsCreditCard2Front />, path: "/payments", check: "payments" },
            { name: "Trip Protection", icon: <BsShieldCheck />, path: "/protection", check: "protection" },
            { name: "Pricing Calendar", icon: <BsCalendarRange />, path: "/pricing-calendar", check: "pricing-calendar" },
            { name: "Coupons", icon: <BsTicketPerforated />, path: "/coupon", check: "coupon" },
            { name: "Tasks", icon: <MdOutlineChecklist />, path: "/tasks", check: "tasks" },
        ],
    },
    {
        title: "STAFF",
        items: [
            { name: "Staff", icon: <HiOutlineUserGroup />, path: "/staff", check: "staff" },
            { name: "Live Staff Map", icon: <MdOutlineMyLocation />, path: "/staff-tracking", check: "staff-tracking" },
            { name: "Shift Allocation", icon: <MdOutlineSchedule />, path: "/shift", check: "shift" },
            { name: "Attendance", icon: <MdOutlineFactCheck />, path: "/attendance", check: "attendance" },
            { name: "Leave / Permission", icon: <MdOutlineEventBusy />, path: "/time-off", check: "time-off" },
            { name: "Departments", icon: <MdOutlineAccountTree />, path: "/departments", check: "departments" },
            { name: "Roles", icon: <MdOutlineAssignmentInd />, path: "/roles", check: "roles" },
        ],
    },
    {
        title: "VEHICLES",
        items: [
            { name: "Brands", icon: <BsTag />, path: "/brand", check: "brand" },
            { name: "Models", icon: <BsCarFrontFill />, path: "/model", check: "model" },
            { name: "Variants", icon: <BsDiagram3 />, path: "/variant", check: "variant" },
            { name: "Cars", icon: <BsCarFrontFill />, path: "/car", check: "cars" },
            { name: "Bikes", icon: <MdOutlineTwoWheeler />, path: "/vehicle-fleet/bikes", check: "bikes" },
            { name: "Services", icon: <MdOutlineBuild />, path: "/vehicle-fleet/services", check: "services" },
        ],
    },

    {
        title: "MANAGEMENT",
        items: [
            { name: "Hubs", icon: <HiOutlineOfficeBuilding />, path: "/hubs", check: "hubs" },
            { name: "Notification Centre", icon: <BsBell />, path: "/notification-centre", check: "notification-centre" },
            { name: "Campaigns", icon: <BsMegaphone />, path: "/campaigns", check: "campaigns" },
            { name: "Send to staff", icon: <BsSend />, path: "/send-to-staff", check: "send-to-staff" },
            { name: "Reviews", icon: <BsStar />, path: "/reviews", check: "reviews" },
            { name: "Settings", icon: <IoSettingsOutline />, path: "/settings", check: "settings" },
        ],
    },
];
